// App.js
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import AuthLayout from "./layouts/AuthLayout";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import DashboardPage from "./pages/Dashboard";
import CoursesPage from "./pages/CoursePage";
import SettingsPage from "./pages/Settings";
import Resume from "./pages/resume";
import BuildResume from "./pages/buildresume";
import Playground from "./pages/Playground";
import ForgotPassword from "./pages/auth/forgot";
import ResetPassword from "./pages/auth/ResetPassword";
import Certificates from "./pages/certificate";
import ConfirmSignup from "./pages/auth/confirmsignup";
import Courses from "./pages/courses";
import QuizList from "./pages/quiz";
import QuizLayout from "./layouts/QuizLayout";
import QuizAttempt from "./components/quiz/quizAttempt";
import QuizResult from "./components/quiz/quizResult";
import StudentLiveClasses from "./pages/liveClasses";
import FinalAssessment from "./pages/finalAssessment";
import FinalAssessmentStart from "./pages/finalAssessmentStart";
import AssessmentLayout from "./layouts/AssessmentLayout";
import Checkout from "./pages/checkout";
import PaymentSuccess from "./pages/paymentSuccess";
import PaymentFailure from "./pages/paymentfailure";

export default function App() {
  return (
    <Routes>
      {/* ---------- PUBLIC ROUTES (NO SIDEBAR/TOPBAR) ---------- */}
      <Route path="/login" element={<AuthLayout><Login /></AuthLayout>} />
      <Route path="/signup" element={<AuthLayout><Signup /></AuthLayout>} />
      <Route path="/confirm-signup" element={<AuthLayout><ConfirmSignup /></AuthLayout>} />
      <Route path="/forgotPassword" element={<AuthLayout><ForgotPassword /></AuthLayout>} />
      <Route path="/resetPassword" element={<AuthLayout><ResetPassword /></AuthLayout>} />

      {/* ---------- PROTECTED ROUTES (WITH DASHBOARD LAYOUT) ---------- */}
      <Route element={<DashboardLayout />}>

        <Route path="/" element={<DashboardPage />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/course/:courseId" element={<CoursesPage />} />
        <Route path="/liveclasses" element={<StudentLiveClasses />} />

        <Route path="/quizzer" element={<QuizList />} />
        <Route path="/practice-lab" element={<Playground />} />
        <Route path="/templates" element={<Resume />} />
        <Route path="/buildresume" element={<BuildResume />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/settings" element={<SettingsPage />} />

      </Route>
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route
        path="/payment-failure"
        element={<PaymentFailure />}
      />
      <Route element={<QuizLayout />}>
        <Route path="/quiz/:id" element={<QuizAttempt />} />
        <Route path="/quiz/:id/result" element={<QuizResult />} />
      </Route>
      <Route element={<AssessmentLayout />}>
        <Route
          path="/course/:courseId/final-assessment/start"
          element={<FinalAssessmentStart />}
        />
        <Route path="/final-assessment/:courseId" element={<FinalAssessment />} />
      </Route>

    </Routes>
  );
}
